import { ComponentType } from "@angular/cdk/overlay";
import { Injectable, TemplateRef } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { firstValueFrom, takeUntil } from "rxjs";
import { ConfirmationDialogComponent } from "../../components/confirmation-dialog/confirmation-dialog.component";
import { GeneratePdfLoaderComponent } from "../../components/generate-pdf-loader/generate-pdf-loader.component";

@Injectable({
  providedIn: "root",
})
export class DialogsService {
  constructor(private dialog: MatDialog) {}

  open(
    c: ComponentType<any> | TemplateRef<any>,
    width: string = "fit-content",
    height: string = "fit-content",
    data?: any,
    closeOnNavigation = true,
    disableClose = false,
  ) {
    const dialogRef = this.dialog.open(c, {
      data,
      width,
      height,
      maxWidth: width,
      maxHeight: height,
      closeOnNavigation,
      autoFocus: false,
      disableClose,
    });
    if (disableClose) {
      dialogRef
        .backdropClick()
        .pipe(takeUntil(dialogRef.afterClosed()))
        .subscribe(async () => {
          const confirmRef = this.dialog.open(ConfirmationDialogComponent, {
            data: {
              title: "Attention",
              message: `Vous avez des modifications non sauvegardées, voulez-vous vraiment quitter la page ?`,
              confirmText: "Rester sur la page",
              cancelText: "Abandonner les modifications",
              values: {
                confirm: false,
                cancel: true,
                backdropClick: false,
              },
            },
          });
          const res = await firstValueFrom(confirmRef.afterClosed());
          if (res) {
            dialogRef.close();
          }
        });
    }
    return dialogRef;
  }

  openPanel(c: ComponentType<any> | TemplateRef<any>, data?: any) {
    return this.dialog.open(c, {
      data,
      position: {
        right: "0px",
      },
      panelClass: "justup-panel",
      width: "288px",
      height: "100%",
      closeOnNavigation: true,
      autoFocus: false,
    });
  }

  async openPdfLoader(process: () => Promise<any>) {
    const dialogRef = this.dialog.open(GeneratePdfLoaderComponent);
    try {
      await process();
    } finally {
      dialogRef.close();
    }
  }
}
